module.exports = __webpack_public_path__ + "static/img/zpbg.67e890b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weekjd/zpbg.png
// module id = kSnL
// module chunks = 2